export default class Device {
	constructor(deviceId) {
		this.id = deviceId;
	}

	getId() {
		return this.id;
	}

	isValid() {
		return !!this.id;
	}
}